import { render, staticRenderFns } from "./message_approval_request.vue?vue&type=template&id=7500cf60"
import script from "./message_approval_request.vue?vue&type=script&lang=js"
export * from "./message_approval_request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports